var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMoreVertical(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon/more_vert_black_24dp (1)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1158_110916)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M9.9987 6.66536C10.9154 6.66536 11.6654 5.91536 11.6654 4.9987C11.6654 4.08203 10.9154 3.33203 9.9987 3.33203C9.08203 3.33203 8.33203 4.08203 8.33203 4.9987C8.33203 5.91536 9.08203 6.66536 9.9987 6.66536ZM9.9987 8.33203C9.08203 8.33203 8.33203 9.08203 8.33203 9.9987C8.33203 10.9154 9.08203 11.6654 9.9987 11.6654C10.9154 11.6654 11.6654 10.9154 11.6654 9.9987C11.6654 9.08203 10.9154 8.33203 9.9987 8.33203ZM9.9987 13.332C9.08203 13.332 8.33203 14.082 8.33203 14.9987C8.33203 15.9154 9.08203 16.6654 9.9987 16.6654C10.9154 16.6654 11.6654 15.9154 11.6654 14.9987C11.6654 14.082 10.9154 13.332 9.9987 13.332Z",
    fill: "#4B6D98"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1158_110916"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    rx: 4,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoreVertical);
export default __webpack_public_path__ + "static/media/more-vertical.8901695953262b547c31f80e6a8965d1.svg";
export { ForwardRef as ReactComponent };